import { createGlobalStyle } from '@xstyled/styled-components'

export const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    padding: 0;
    overflow-x: hidden;
    color: ${({ theme }) => theme.colors.typoPrimary};
    background-color: ${({ theme }) => theme.colors.white};
  }

  #root {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }

  @media (min-width: 1024px) {
      ::-webkit-scrollbar {
        width: 12px;
      }

      ::-webkit-scrollbar-thumb {
        border: none;
        border-radius: 4px;
        box-shadow: inset 0 0 10px 10px ${({ theme }) => theme.colors.lightGray4};

        &:hover {
          box-shadow: inset 0 0 10px 10px ${({ theme }) => theme.colors.gray};
        }
      }

      ::-webkit-scrollbar-track {
        margin: 6px;

        &:hover {
          background-color: ${({ theme }) => theme.colors.lightGray2};
        }
      }

      ::-webkit-scrollbar-button {
        display: none;
      }
  }
`
